import { DeserializeFilters } from '../../../hooks/table-pages/use-endpoint-query-parameters'
import qs from 'qs'
import dayjs from 'dayjs'
import FormValues from '../components/filters-form/types/form-values'
import getBetweenByOneDate from '../../../helpers/filters/get-between-by-one-date'

export const deserializeFilters: DeserializeFilters = filtersString => {
    const formValues = qs.parse(filtersString) as Partial<FormValues>
    const {
        client,
        shipmentId,
        labelName,
        month,
        materialType,
        stampId,
        materialWidth,
        clientDeliveryDate,
    } = formValues

    const filters: Record<string, any> = {}

    if (client) {
        filters.client = { documentId: { $eq: client } }
    }

    if (shipmentId) {
        const id = Number(shipmentId)
        if (!Number.isNaN(id)) {
            filters.id = { $eq: id }
        }
    }

    if (labelName?.trim()) {
        filters.shipment_positions = {
            labelName: { $containsi: labelName.trim() },
        }
    }

    if (month) {
        const monthDate = dayjs(month)
        if (monthDate.isValid()) {
            filters.createdAt = {
                $gte: monthDate.startOf('month').toISOString(),
                $lte: monthDate.endOf('month').toISOString(),
            }
        }
    }

    if (materialType) {
        filters.materialRequirements = {
            material_type: { documentId: { $eq: materialType } },
        }
    }

    if (stampId?.trim()) {
        filters.stamp = { number: { $containsi: stampId.trim() } }
    }

    if (materialWidth !== undefined && materialWidth !== null && materialWidth !== '') {
        const width = Number(materialWidth)
        if (!Number.isNaN(width)) {
            filters.calculated = { materialWidth: { $eq: width } }
        }
    }

    if (clientDeliveryDate) {
        const date = dayjs(clientDeliveryDate)
        if (date.isValid()) {
            filters.clientDeliveryDate = getBetweenByOneDate(date)
        }
    }

    return filters
}
